import React from 'react';

function About() {
  return (
    <h1>This is the About Page!</h1>
  );
}

export default About;